import React from 'react';

/**
 * Shared header control for recent-deals blotters — filter by value date.
 */
export default function RecentDealsDateFilter({
  title = 'Recent Deals',
  filterDateYmd,
  onFilterDateChange,
  onRefresh,
  refreshing = false,
  extraActions = null
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        marginBottom: 16,
        flexWrap: 'wrap',
        justifyContent: 'space-between'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0 }}>{title}</h3>
        <div style={{ minWidth: 180 }}>
          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 500 }}>
            Filter by Value Date
          </label>
          <input
            type="date"
            className="form-control"
            value={filterDateYmd || ''}
            onChange={(e) => onFilterDateChange(e.target.value)}
            disabled={!filterDateYmd && refreshing}
          />
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {extraActions}
        {typeof onRefresh === 'function' && (
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={onRefresh}
            disabled={refreshing}
          >
            {refreshing ? 'Refreshing...' : 'Refresh'}
          </button>
        )}
      </div>
    </div>
  );
}
